/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Native_QInputs */

const en_mk_faq_native_q = /** @type {(inputs: Mk_Faq_Native_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use my existing Claude Code or Codex subscription?`)
};

const id_mk_faq_native_q = /** @type {(inputs: Mk_Faq_Native_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa memakai langganan Claude Code atau Codex yang sudah saya punya?`)
};

/**
* | output |
* | --- |
* | "Can I use my existing Claude Code or Codex subscription?" |
*
* @param {Mk_Faq_Native_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_native_q = /** @type {((inputs?: Mk_Faq_Native_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Native_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_native_q(inputs)
	return en_mk_faq_native_q(inputs)
});